/* ============================================================
   US-Parts24 · R511 — Bestseller-Galerie (sections/usparts-bestseller-galerie).

   Rechner (≥ 990 px, feiner Zeiger): Der Abschnitt ist so hoch wie der
   Bildschirm plus der Weg, den die Reihe seitwärts zurücklegt. Solange er
   angeheftet ist, wird aus dem senkrechten Scrollstand ein transform der
   Reihe. Lenis glättet den Scroll, also gleitet auch die Reihe — ohne
   eigenen Takt, ohne Einrasten, ohne Autoplay.

   Handy/Tablet, „Bewegung reduzieren", Leistungsstufe „sparsam", Editor:
   nichts wird angeheftet. Die Reihe scrollt der Browser selbst (CSS);
   hier wird nur der Zähler mitgeführt.

   Leistung (Regeln aus R508): Lagen werden zwischengespeichert und nur bei
   Größenänderung neu gemessen; im Takt wird nur scrollTop gelesen und nur
   bei Änderung geschrieben.
   ============================================================ */
(function () {
  'use strict';

  var wurzeln = document.querySelectorAll('[data-usp-galerie]');
  if (!wurzeln.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = Boolean(window.Shopify && window.Shopify.designMode);
  var desktop = window.matchMedia('(min-width: 990px) and (pointer: fine)');
  /* Die Reihe legt pro Pixel senkrechtem Scroll 1,35 px seitwärts zurück —
     bei 1 : 1 dauerte die Galerie bei 1920 px über zwei Bildschirmhöhen. */
  var TEMPO = 1.35;

  Array.prototype.forEach.call(wurzeln, starten);

  function starten(wurzel) {
    var stick = wurzel.querySelector('.usp-bsg__stick');
    var bahn = wurzel.querySelector('[data-usp-galerie-bahn]');
    var reihe = wurzel.querySelector('[data-usp-galerie-reihe]');
    var nrEl = wurzel.querySelector('[data-usp-galerie-nr]');
    var fort = wurzel.querySelector('[data-usp-galerie-fort]');
    var zurueck = wurzel.querySelector('[data-usp-galerie-zurueck]');
    var weiter = wurzel.querySelector('[data-usp-galerie-weiter]');
    if (!stick || !bahn || !reihe) return;
    var karten = reihe.querySelectorAll('[data-usp-galerie-karte]');
    var n = karten.length;
    if (n < 2) return;

    var galerie = false, ueberstand = 0, weg = 0, oben = 0, schritt = 0;
    var zuletztX = -1, zuletztF = -1, zuletztNr = -1, angefordert = false;
    var scroller = null;

    function darfGalerie() {
      return desktop.matches && !reduce && !inEditor &&
        !(window.uspMotion && window.uspMotion.stufe === 'sparsam');
    }
    function scrollerBestimmen() {
      /* Ab 990 px scrollt .page-wrapper, nicht das Fenster (base.css). */
      var pw = window.innerWidth >= 990 ? document.querySelector('.page-wrapper') : null;
      scroller = pw && getComputedStyle(pw).overflowY !== 'visible' ? pw : null;
    }
    function scrollTop() { return scroller ? scroller.scrollTop : (window.scrollY || document.documentElement.scrollTop); }
    function bildHoehe() { return scroller ? scroller.clientHeight : window.innerHeight; }

    function messen() {
      scrollerBestimmen();
      var soll = darfGalerie();
      if (soll) {
        /* Passt der Inhalt nicht aufs Bild (kleiner Laptop quer), lieber
           normal durchlaufen lassen als etwas abschneiden. */
        wurzel.classList.add('is-galerie');
        var zuHoch = stick.scrollHeight > bildHoehe() + 2;
        if (zuHoch) soll = false;
      }
      if (!soll) {
        wurzel.classList.remove('is-galerie');
        wurzel.style.height = '';
        reihe.style.transform = '';
        zuletztX = -1;
      }
      galerie = soll;
      schritt = karten[1].getBoundingClientRect().left - karten[0].getBoundingClientRect().left;
      if (galerie) {
        ueberstand = Math.max(0, reihe.offsetWidth - bahn.clientWidth);
        weg = Math.round(ueberstand / TEMPO);
        wurzel.style.height = (bildHoehe() + weg) + 'px';
        oben = wurzel.getBoundingClientRect().top + scrollTop();
        bahn.scrollLeft = 0;
      }
      zuletztF = -1; zuletztNr = -1;
      takt();
    }

    function anteil() {
      if (galerie) return weg > 0 ? Math.max(0, Math.min(1, (scrollTop() - oben) / weg)) : 0;
      var max = bahn.scrollWidth - bahn.clientWidth;
      return max > 0 ? Math.max(0, Math.min(1, bahn.scrollLeft / max)) : 0;
    }

    function zeichnen() {
      angefordert = false;
      var p = anteil();
      if (galerie) {
        var x = Math.round(p * ueberstand);
        if (x !== zuletztX) { zuletztX = x; reihe.style.transform = 'translate3d(' + (-x) + 'px,0,0)'; }
      }
      var f = Math.round(p * 1000);
      if (f !== zuletztF && fort) { zuletztF = f; fort.style.transform = 'scaleX(' + (f / 1000) + ')'; }
      var nr = Math.min(n, Math.round(p * (n - 1)) + 1);
      if (nr !== zuletztNr) {
        zuletztNr = nr;
        if (nrEl) nrEl.textContent = (nr < 10 ? '0' : '') + nr;
      }
      var amAnfang = p <= 0.001, amEnde = p >= 0.999;
      if (zurueck && zurueck.disabled !== amAnfang) zurueck.disabled = amAnfang;
      if (weiter && weiter.disabled !== amEnde) weiter.disabled = amEnde;
    }
    function takt() { if (!angefordert) { angefordert = true; requestAnimationFrame(zeichnen); } }

    /* Seite zu einem Stand der Galerie scrollen (Pfeile, Tastatur-Fokus) */
    function zuStand(p, sofort) {
      var ziel = oben + Math.max(0, Math.min(1, p)) * weg;
      var l = window.uspSmooth && window.uspSmooth.lenis;
      if (l) l.scrollTo(ziel, { immediate: Boolean(sofort) });
      else if (scroller) scroller.scrollTo({ top: ziel, behavior: sofort || reduce ? 'auto' : 'smooth' });
      else window.scrollTo({ top: ziel, behavior: sofort || reduce ? 'auto' : 'smooth' });
    }
    function blaettern(richtung) {
      if (galerie) {
        var x = anteil() * ueberstand + richtung * schritt;
        zuStand(ueberstand > 0 ? x / ueberstand : 0);
      } else {
        bahn.scrollBy({ left: richtung * schritt, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    if (zurueck) zurueck.addEventListener('click', function () { blaettern(-1); });
    if (weiter) weiter.addEventListener('click', function () { blaettern(1); });

    /* Tastatur: eine Karte bekommt den Fokus → im Galerie-Modus die SEITE
       dorthin scrollen (die Bahn selbst ist dann zu und darf nicht springen). */
    reihe.addEventListener('focusin', function (e) {
      if (!galerie) return;
      var karte = e.target.closest ? e.target.closest('.usp-bsg__karte') : null;
      if (!karte) return;
      bahn.scrollLeft = 0;
      var rand = parseFloat(getComputedStyle(reihe).paddingLeft) || 0;
      zuStand(ueberstand > 0 ? (karte.offsetLeft - rand) / ueberstand : 0, true);
    });

    /* Trackpad seitwärts über der Galerie: in senkrechten Scroll übersetzen,
       damit die Geste nicht ins Leere geht. */
    bahn.addEventListener('wheel', function (e) {
      if (!galerie || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      var l = window.uspSmooth && window.uspSmooth.lenis;
      var d = e.deltaX / TEMPO;
      if (l) l.scrollTo(l.targetScroll + d);
      else if (scroller) scroller.scrollTop += d;
      else window.scrollBy(0, d);
    }, { passive: false });

    function scrollZielBinden() {
      var z = scroller || window;
      z.addEventListener('scroll', takt, { passive: true });
      return z;
    }
    scrollerBestimmen();
    var ziel = scrollZielBinden();
    bahn.addEventListener('scroll', function () { if (!galerie) takt(); }, { passive: true });

    var messTakt = null;
    function spaeterMessen() { clearTimeout(messTakt); messTakt = setTimeout(messen, 120); }
    window.addEventListener('resize', spaeterMessen, { passive: true });
    desktop.addEventListener('change', function () {
      ziel.removeEventListener('scroll', takt);
      messen();
      ziel = scrollZielBinden();
    });
    /* Abschnitte darüber wachsen (Bilder, Filme) → Lage neu messen */
    if ('ResizeObserver' in window) {
      var main = document.getElementById('MainContent') || document.body;
      var letzteHoehe = 0;
      new ResizeObserver(function () {
        var h = main.offsetHeight;
        if (Math.abs(h - letzteHoehe) > 1) { letzteHoehe = h; spaeterMessen(); }
      }).observe(main);
    }
    window.addEventListener('load', messen, { once: true });
    if (window.uspMotion && window.uspMotion.beiStufe) window.uspMotion.beiStufe(function () { messen(); });
    document.addEventListener('shopify:section:load', messen);
    messen();
  }
})();
